module.exports = __webpack_public_path__ + "static/media/contacts3.2313d428.png";